// CategoryPill — supply category as a solid-fill, white-text pill.
// Five categories (Chemical / Paper / Equipment / Consumable / Other), each
// with its own brand color from SUPPLY_CATEGORY_COLORS.

import {
  SUPPLY_CATEGORY_COLORS,
  type SupplyCategory,
} from '../design-tokens';

export interface CategoryPillProps {
  category: SupplyCategory;
  className?: string;
}

export function CategoryPill({ category, className }: CategoryPillProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[11px] font-semibold text-white ${className ?? ''}`}
      style={{ backgroundColor: SUPPLY_CATEGORY_COLORS[category] }}
    >
      {category}
    </span>
  );
}
